import { render, staticRenderFns } from "./DaftarKios.vue?vue&type=template&id=53f506ca&scoped=true&"
import script from "./DaftarKios.vue?vue&type=script&lang=js&"
export * from "./DaftarKios.vue?vue&type=script&lang=js&"
import style0 from "./DaftarKios.vue?vue&type=style&index=0&id=53f506ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f506ca",
  null
  
)

export default component.exports